import React, { Component } from 'react';

import '../../App.css';

// i18n
import { withTranslation } from 'react-i18next';

// Routes
import { withRouter } from 'react-router-dom';

// redux
import { push } from '../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import NotificationsList from './notificationsList';

// Analytics
import ux from '../../utils/uxAnalyticsUtil';

export class Notifications extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    ux.trackPageView(this.props.match.path);
  }

  render() {
    const { t } = this.props;
    return (
      <main style={{maxWidth: 760, margin: '0 auto', padding: '24px 16px',
        color: 'var(--br-text)'}}>
        <header style={{display: 'flex', alignItems: 'baseline',
          justifyContent: 'space-between', gap: 16}}>
          <h1>{t('YourNotifications')}</h1>
          <span style={{color: 'var(--br-muted)'}}>{`(${t('BETA')})`}</span>
        </header>
        <NotificationsList />
      </main>
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  userProfile: state.user.userProfile,
  notifications: state.notification.notifications
});

const mapDispatchToProps = dispatch => bindActionCreators({
  changePage: newPage => push(newPage)
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Notifications)));
